$(function () {
  $(document).on('click', '#open-main-drawer', function (e) {
    e.preventDefault();
    const printerId = $(this).data('printer-id');
    const printerName = $(this).data('printer-name');
    const printerIpAddress = $(this).data('printer-ip-address');
    const printerType = $(this).data('printer-type');

    if (!printerId) {
      return;
    }

    if (window.ReactNativeWebView) {
      const message = {
        action: 'open_drawer',
        printer: {
          printer_id: printerId,
          name: printerName,
          ip_address: printerIpAddress,
          type: printerType,
        },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  });
});
